import React from 'react';
import businessOwnerHeaderImg from '../../../../assets/journaler/solutions/business.png'
import accountantHeaderImg from '../../../../assets/journaler/solutions/accountantimage.png'
import financialInstitutionHeaderImg from '../../../../assets/journaler/solutions/Artboard.png'
import UPDATED_WALLET from '../../../../assets/journaler/solutions/UPDATED_WALLET.png'
import xero_account from '../../../../assets/journaler/solutions/input-xero.png'
import mark_account from '../../../../assets/journaler/solutions/mark-account.png'
import imgOne from '../../../../assets/journaler/solutions/iconOne.png'
import imgTwo from '../../../../assets/journaler/solutions/iconTwo.png'
import imgThree from '../../../../assets/journaler/solutions/iconThree.png'
import AMLProof from '../../../../assets/journaler/solutions/AML_proof.png'

import styles from '../index.module.css'
export const header = {
  accountant: {
    title: 'Crypto accounting made simple for ',
    gradient: 'Accountants',
    des: 'Journaler helps accounting firms consolidate crypto activity, automate reconciliation, and generate audit-ready financial data without relying on spreadsheets or manual workflows.',
    subtitle: 'Accounting Firms & Crypto Clients',
    subtitle2: 'Make crypto accounting effortless',
    subDes: 'Quickly understand client crypto activity, respond faster, and share clear reports. No complex data clean up or client involvement required.',
    btn: 'Book a demo',
    img: accountantHeaderImg
  },
  businessOwner: {
    title: 'Crypto Accounting Software for',
    gradient: 'Business Owners',
    des: `Journaler helps business owners and finance teams gain full visibility into crypto activity, automate accounting workflows, and maintain accurate financial records without relying on spreadsheets.`,
    subtitle: 'Crypto-Active Businesses',
    subtitle2: 'Save time and keep your crypto books accurate',
    subDes: 'Track wallet and exchange activity with clean, structured data that fits into standard accounting workflows.',
    btn: 'Book a demo',
    img: businessOwnerHeaderImg
  },
  financialInstitution: {
    title: 'Crypto Accounting Software for',
    gradient: 'Financial Institutions',
    des: 'Journaler provides enterprise-grade crypto accounting and reconciliation for institutions managing high-volume digital asset operations across exchanges, custody platforms, and wallets.',
    subtitle: 'Institutions & Regulated Crypto Businesses',
    subtitle2: 'Reduce risk and stay audit-ready at scale.',
    subDes: 'Manage large-scale crypto transaction data with structured, compliance-ready records for reporting and internal controls.',
    btn: 'Book a demo',
    img: financialInstitutionHeaderImg
  }
}

export const description = {
  accountant: {
    header1: `Made with`,
    header2: `in mind`,
    gradient: `accounting professionals and firms`,
    des: `Grow your client base with our complete suite of tools and resources that will help enhance your 
    financial services from end-to-end. Optimise how you track, manage, and reconcile crypto assets – with 100% accuracy every single time.`
  },
  businessOwner: {
    header1: `Streamlining`,
    header2: `from end-to-end`,
    gradient: 'crypto accounting for business',
    des: `Drive the growth of your business and securely manage your digital assets with our intuitive crypto accounting software. Gain control over your 
    crypto asset activity with a full suite of resources and tools, helping you make smarter financial decisions from day one.`
  },
  financialInstitution: {
    header1: `Optimising your`,
    header2: ``,
    gradient: 'financial management & accounting',
    des: `Our intuitive crypto accounting software helps you stay compliant, so you can meet your reporting 
    obligations on time. Utilise our complete suite of advanced accounting tools to 
    efficiently manage your portfolios, drive smart financial decisions, and accurately monitor digital asset data. We make institutional accounting easy, instantly.`
  },
}

export const lastPart = {
  accountant: {
    header1: 'Simplify your',
    header2: 'workflow',
    subHeader: 'crypto accounting'
  },
  businessOwner: {
    header1: 'Unlock',
    header2: 'for business',
    subHeader: 'advanced accounting tools'
  },

  financialInstitution: {
    header1: 'Transform your ',
    header2: 'and',
    subHeader: 'digital asset',
    subHeader2: 'accounting operations'
  }
}



export const contentsWallet = {
  accountant: {
    header: (
      <p className={styles.titleMidHeader}>Client portfolio
        <span className={styles.titleMidHeaderGradient}> management</span>
      </p>
    ),
    des: 'Manage multiple crypto-active clients from one platform',
    image: UPDATED_WALLET,
    content: [
      'Consolidate multiple client wallets and exchanges in a single dashboard',
      'Track balances, transaction history, and asset movements across platforms',
      'Reduce time spent chasing missing or incomplete client data'
    ]
  },
  businessOwner: {
    header: (
      <p className={styles.titleMidHeader}>Wallet & Exchange
        <span className={styles.titleMidHeaderGradient}> Tracking</span>
      </p>
    ),

    des: `Track all crypto activity in one place`,
    image: UPDATED_WALLET,
    content: [
      'Consolidate business wallets and exchange accounts in one platform',
      'Monitor balances, transaction history, and asset movements',
      'Maintain a complete record of on-chain and exchange activity'
    ]
  },
  financialInstitution: {
    header: (
      <p className={styles.titleMidHeader}>
        <span className={styles.titleMidHeaderGradient}> High-Volume </span>
        Transaction Accounting
      </p>
    ),
    des: `Handle institutional-scale crypto activity`,
    image: UPDATED_WALLET,
    content: [
      'Ingest large volumes of transaction data from exchanges and wallets',
      'Normalise on-chain and off-chain activity into a unified',
      'Maintain accurate records across trading, treasury, and operations'
    ]
  },
}

export const contentsIntegrate = {
  accountant: {
    header: (
      <p className={styles.titleMidHeader}>Crypto
        <span className={styles.titleMidHeaderGradient}> Reconciliation & Bookkeeping </span>
      </p>
    ),
    des: 'Reconcile on-chain and off-chain crypto activity',
    image: xero_account,
    content: [
      'Reconcile trades, transfers, fees, and balances accurately',
      'Capture both wallet and exchange activity in one accounting view',
      'Eliminate spreadsheet-based reconciliation workflows'
    ]
  },
  businessOwner: {
    header: (
      <p className={styles.titleMidHeader}>
        <span className={styles.titleMidHeaderGradient}>Crypto Reconciliation </span>
        for Finance Teams
      </p>
    ),
    des: `Automate reconciliation and reduce manual work`,
    image: xero_account,
    content: [
      'Reconcile deposits, withdrawals, trades, and transfers accurately',
      'Convert crypto activity into structured accounting records',
      'Eliminate spreadsheet-based reconciliation workflows'
    ]
  },
  financialInstitution: {
    header: (
      <p className={styles.titleMidHeader}>
        Custody & Treasury
        <span className={styles.titleMidHeaderGradient}> Reconciliation </span>
      </p>
    ),
    des: `Track asset movements across institutional wallets`,
    image: xero_account,
    content: [
      'Reconcile custody movements, internal transfers, and balances',
      'Maintain full visibility across treasury and operational wallet',
      'Ensure completeness without relying on manual CSV workflows'
    ]
  },
}

export const collabIntegrate = {
  accountant: {
    header: (
      <div className={styles.titleMidHeader}>
        Financial
        <span className={styles.titleMidHeaderGradient}> Reporting & Journal </span>
        Preparation
      </div>
    ),
    des: 'Generate accounting-ready crypto records',
    image: mark_account,
    content: [
      'Produce structured transaction data for journals and reporting',
      'Support gain and loss calculations using standard accounting treatments',
      'Maintain consistency across reporting periods and financial state'
    ]
  },
  businessOwner: {
    header: (
      <p className={styles.titleMidHeader}>
        Financial
        <span className={styles.titleMidHeaderGradient}> Reporting & Record </span>
        Keeping
      </p>
    ),
    des: `Maintain accurate financial data for reporting`,
    image: mark_account,
    content: [
      'Apply consistent fiat conversion for all crypto transactions',
      'Generate accounting-ready records for financial statements',
      'Maintain historical records across reporting periods'
    ]
  },
  financialInstitution: {
    header: (
      <p className={styles.titleMidHeader}>
        Compliance & Audit
        <span className={styles.titleMidHeaderGradient}> Reporting </span>
      </p>
    ),
    des: `Support regulatory and internal reporting requirements`,
    image: mark_account,
    content: [
      'Maintain full transaction traceability for audit purposes',
      'Generate structured, review-ready accounting records',
      'Support internal controls and compliance workflows'
    ]
  },
}

export const keyFeature = {
  accountant: {
    title: 'Key features',
    content: [
      {
        img: imgOne,
        title: 'Accounting Integration',
        des: [
          'Export crypto data directly into Xero and QuickBooks.',
          'Ensure crypto activity flows into the general ledger.',
        ],
      },
      {
        img: imgTwo,
        title: 'Multi-Client & Multi-Wallet Setups',
        des: [
          'Manage multiple client data within a single platform.',
          'Scales easily across accounting firms and client volumes',
        ],
      },
      {
        img: imgThree,
        title: 'Audit & Compliance Trails',
        des: [
          'Maintain full transaction traceability for every crypto record.',
          'Support internal reviews, external audits, and tax preparation with confidence.',
        ]
      }
    ]
  },
  businessOwner: {
    title: 'Key features',
    content: [
      {
        img: imgOne,
        title: 'Accounting Integration',
        des: [
          'Export crypto data directly into Xero and QuickBooks.',
          'Ensure crypto activity flows into the general ledger.',
        ],
      },
      {
        img: imgTwo,
        title: 'Multi-Client & Multi-Wallet Setups',
        des: [
          'Track multiple operational wallets and exchange account',
          'Ideal for businesses managing payments, treasury, and trading activity.',
        ],
      },
      {
        img: imgThree,
        title: 'Reports & Exports',
        des: [
          'Export clean datasets for financial reporting, reviews, and tax preparation.',
          'All data is standardised and ready for accounting workflows.',
        ]
      }
    ]
  },
  financialInstitution: {
    title: 'Key features',
    content: [
      {
        img: imgTwo,
        title: 'Multi-Entity & Institutional Structures',
        des: [
          'Manage multiple legal entities, portfolios, and accounts within one platform.',
          'Designed for funds, exchanges, and complex organisational structures.',
        ],
      },
      {
        img: AMLProof,
        title: 'AML & Proof of Funds',
        des: [
          'Support transaction monitoring, source-of-funds tracking, and audit trails.',
          'Enable compliance teams to review crypto activity with confidence',
        ],
      },
      {
        img: imgThree,
        title: 'Institutional Reports & Exports',
        des: [
          'Export clean, structured datasets for financial reporting, audits, and regulatory reviews.',
          'All data is standardised and accounting-ready.',
        ]
      }
    ]
  }
}